import { ApiService } from "src/network/apiService";
import { IBusinessNumberModel, IAddNumbersToApplicationRequestModel, INewBusinessNumberModel, IManagedApplicationSettings, IApplicationNumber, IApplicationNumberUpdate, IApplicationNumberRemove, IApplicationNumberUpdateNumbers, IUpdateApplicationRequest } from "src/types/models/apiModels";


export class ApplicationSubmitProcessorViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async submitApplicationAsync(
        applicationId: string,
        applicationName: string,
        description: string,
        businessNumbers: IApplicationNumberUpdateNumbers[],
        managedApplicationSettings?: IManagedApplicationSettings
        ,) {
        const url = `/onboard/application/${applicationId}`;

        const body: IUpdateApplicationRequest = {
            name: applicationName,
            description: description,
            businessNumbers: businessNumbers,
            managedApplicationSettings: managedApplicationSettings
        };

        // todo: make sure to specify the request and response types
        const response: any = this.apiService.putAsync(url, body);

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                return { result: true };
            } else {
                return {
                    result: false,
                    error: response.scResponse?.message,
                };
            }
        }

        return { result: false, error: "response not returned" }
    }

    async submitNumberAdditionAsync(
        applicationId: string,
        businessNumber: IBusinessNumberModel,
    ): Promise<{ result: boolean; error?: string }> {
        const url = `/onboard/application/${applicationId}/numbers/add`;

        const body: IAddNumbersToApplicationRequestModel = {
            businessNumbers: [
                {
                    businessNumber: businessNumber.businessNumber,
                    branding: {
                        brandingName: businessNumber.branding.brandingName,
                        defaultIntent: businessNumber.branding.defaultIntent,
                        defaultTTLInMinutes: businessNumber.branding.defaultTTLInMinutes,
                        cleanupPushContent: businessNumber.branding.cleanupPushContent,
                        setupPushContent: businessNumber.branding.setupPushContent,
                        imageFile: businessNumber.branding.imageFile
                    },
                    managedNumberSettings: {
                        cPaaSProvider: businessNumber.managedNumberSettings.cPaaSProvider,
                        screenSettings: businessNumber.managedNumberSettings.screenSettings
                    }
                }
            ]
        };

        // todo: make sure to specify the request and response types
        const response: any = this.apiService.postAsync(url, body);

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                return { result: true };
            } else {
                return {
                    result: false,
                    error: response.scResponse?.message,
                };
            }
        }

        return { result: false, error: "response not returned" }
    }

    // async submitNumberUpdateAsync(
    //     businessId: string,
    //     numberToUpdate: IBusinessNumberModel
    // ): Promise<{ result: boolean; error?: string }> {
    //     const url = `/onboard/business/${businessId}/number/${numberToUpdate.businessNumber}`

    //     const body: INewBusinessNumberModel = {
    //         businessNumber: numberToUpdate.businessNumber,
    //         branding: {
    //             brandingName: numberToUpdate.branding.brandingName,
    //             defaultIntent: numberToUpdate.branding.defaultIntent,
    //             defaultTTLInMinutes: numberToUpdate.branding.defaultTTLInMinutes,
    //             cleanupPushContent: numberToUpdate.branding.cleanupPushContent,
    //             setupPushContent: numberToUpdate.branding.setupPushContent,
    //             imageFile: numberToUpdate.branding.imageFile
    //         },
    //         managedNumberSettings: {
    //             cPaaSProvider: numberToUpdate.managedNumberSettings.cPaaSProvider,
    //             screenSettings: numberToUpdate.managedNumberSettings.screenSettings
    //         }
    // //     };

    //     // todo: make sure to specify the request and response types
    //     const response: any = this.apiService.putAsync(url, body);

    //     if (response) {
    //         if (response.scResponse && response.scResponse.code === 2000) {
    //             return { result: true };
    //         } else {
    //             return {
    //                 result: false,
    //                 error: response.scResponse?.message,
    //             };
    //         }
    //     }

    //     return { result: false, error: "response not returned" }
    // }

    async unLinkNumberAsync(applicationBundleId: string, businessNumbers: string[]): Promise<{ result: boolean; error?: string }> {
        const url = `/onboard/application/${applicationBundleId}/numbers/remove`

        console.log(`unLinkNumberAsync ${url}`)
        const body = {
            businessNumbers: businessNumbers
        }
        const response: any = this.apiService.putAsync(url, body);

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                return { result: true };
            } else {
                return {
                    result: false,
                    error: response.scResponse?.message,
                };
            }
        }

        return { result: false, error: "response not returned" }
    }
}